import Select from './select';
import './styles.css';

export default function ReviewSessionExerciseTable({
  rows,
  tournamentGames,
  selectButtonText = 'Select',
  selectButtonTextChanged = 'Selected',
  onSelectChange,
  onSelectButtonClick,
  withWrapper = true
}) {
  if (!rows?.length) return <span className="loader"></span>;

  const table = (
    <table className="review-session-assign-table">
      <tbody>
        {rows.map((row, index) => {
          const isUpdated = row.updated;
          return(
            <tr key={index} className={`${row.disabled ? 'disabled' : ''}`}>
              <td>
                <b>{row.name}</b><br/>
                <span>{row.stage}</span>
              </td>
              <td>
                <Select
                  row={row}
                  availableGames={tournamentGames}
                  onSelectChange={onSelectChange}
                  selectedValue={row.gameType}
                  disabled={row.updated}
                />
              </td>
              {
                onSelectButtonClick && 
                  <td>
                    <button
                      disabled={isUpdated}
                      className="button button-blue"
                      onClick={() => onSelectButtonClick(row)}
                    >
                      {isUpdated ? selectButtonTextChanged : selectButtonText}
                    </button>
                  </td>
              }
            </tr>
          )
        }
      )}
      </tbody>
    </table>
  );

  return withWrapper ? (
    <div className="review-session-assign-table-wrapper">{table}</div>
  ) : (
    table
  );
}
